<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-redeem"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                </div>
                <div class="modal-base-body">
                    <BuyConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'buy'"
                    />
                    <DefaultConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'default'" 
                    />
                    <DeliveryConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'delivery'"
                    />
                    <DrawConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'draw'"
                    />
                    <InterfaceConfirmRedeem
                        :lbl="lbl"
                        :campaign="campaign"
                        v-if="type == 'interface'"
                    />
                </div>
                <div class="modal-base-footer">
                    <TwoButtonRow
                        secondaryBtnId="cancel_redeem_btn"
                        secondaryBtnMsg="ยกเลิก"
                        @clickSecondaryBtn="cancel"
                        primaryBtnId="btn-confirm"
                        primaryBtnMsg="ยืนยัน"
                        @clickPrimaryBtn="confirm"
                    />
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
//helper
import Locale from "@/helper/locale/locale.js";
//component confirm redeem
import BuyConfirmRedeem from "./Component/BuyConfirmRedeem.vue";
import DefaultConfirmRedeem from "./Component/DefaultConfirmRedeem.vue";
import DeliveryConfirmRedeem from "./Component/DeliveryConfirmRedeem.vue";
import DrawConfirmRedeem from "./Component/DrawConfirmRedeem.vue";
import InterfaceConfirmRedeem from "./Component/InterfaceConfirmRedeem.vue";
//component button
import TwoButtonRow from "@/components/Button/TwoButtonRow.vue";
export default {
    name: "ConfirmRedeemModal",
    components: {
        //confirm redeem
        BuyConfirmRedeem,
        DefaultConfirmRedeem,
        DeliveryConfirmRedeem,
        DrawConfirmRedeem,
        InterfaceConfirmRedeem,
        //button
        TwoButtonRow
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            headline: "",
            type: "",
            //config
            campaign: null,
            tag: null,

            busModal: null
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        //event
        confirm: function() {
            window._lt('send', 'cv', {
            type: 'ConfirmReward'
            },['2360d21e-79ce-4697-9bc0-02f5f2555aef']);

            window._lt('send', 'cv', {
            type: 'ConfirmRedeem'
            },['2360d21e-79ce-4697-9bc0-02f5f2555aef']);

            window.fbq('trackCustom', 'ConfirmRedeemButton');

            window.fbq('trackCustom', 'ConfirmRewardButton');

            window.gtag_report_conversion(window.location.href,'AW-970877309/Tv2DCN3egaQDEP3S-c4D'); 

            window.gtag_report_conversion(window.location.href,'AW-970877309/ZprcCKqt-6MDEP3S-c4D'); 

            this.hide();
            this.controller.eventClickConfirm({ tag: this.tag });

            
        },
        cancel: function() {
            this.hide();
            this.controller.eventClickCancel({ tag: this.tag });
        },
        //initial
        initialModal: function() {
            if (!this.campaign.delivered) {
                switch (this.campaign.type) {
                    case Vue.CampaignType.Buy:
                        this.type = "buy";
                        break;
                    case Vue.CampaignType.Draw:
                        this.type = "draw";
                        break;
                    case Vue.CampaignType.Interface:
                        this.type = "interface";
                        break;
                    case Vue.CampaignType.Free:
                    case Vue.CampaignType.Deal:
                    case Vue.CampaignType.Voucher:
                        this.type = "default";
                        break;
                }
            } else {
                this.type = "delivery";
            }

            this.$bvModal.show(this.modalId);
        },
        //modal
        show: function(config) {
            this.campaign = config.campaign;
            this.tag = config.tag;

            this.initialModal();
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
</style>
